import React, { memo, useMemo } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './LeftSideBar.module.scss';
import { Link, withRouter } from 'react-router-dom';
import { getTopicsNav } from 'redux/modules/topics';

const SideItem = memo(({ name, icon, path, isCurrent }) => {
  return (
    <Link
      className={cx(styles.sideItem, isCurrent && styles.highlight)}
      to={path}
    >
      <div>
        <FontAwesomeIcon icon={icon} />
      </div>
      <span>{name}</span>
    </Link>
  );
});

SideItem.propTypes = {
  name: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  isCurrent: PropTypes.bool.isRequired,
};

const LeftSideBar = ({ topics, url }) => {
  const home = useMemo(
    () => ({ name: 'Personal Feed', icon: 'home', path: '/forum/' }),
    []
  );
  const all = useMemo(
    () => ({ name: 'All Topics', icon: 'list', path: '/forum/all/' }),
    []
  );
  return (
    <div className={styles.mainContainer}>
      <SideItem {...home} isCurrent={home.path === url} />
      <span>YOUR SUBJECTS & INTERESTS</span>
      {!topics.length && (
        <div className={styles.notopic}>
          (You are not subscribed to any topic)
        </div>
      )}
      <div className={styles.listContainer}>
        {topics.map(topic => (
          <SideItem
            key={topic.value}
            {...topic}
            isCurrent={topic.path === url}
          />
        ))}
        <SideItem {...all} isCurrent={all.path === url} />
      </div>
    </div>
  );
};

LeftSideBar.propTypes = {
  topics: PropTypes.array.isRequired,
  url: PropTypes.string.isRequired,
};

export default withRouter(
  connect((state, { match: { url } }) => ({
    topics: getTopicsNav(state).sort((a, b) =>
      a.name < b.name ? -1 : a.name > b.name ? 1 : 0
    ),
    url,
  }))(LeftSideBar)
);
